export default __webpack_public_path__ + "static/media/fog.13720216.png";